import { parseDomain, fromUrl, ParseResultType } from "parse-domain";
export * from "punycode";

const { Listed } = ParseResultType;

const INSECURE = "http://";
const SECURE = "https://";

const isValidTldAndHasDomain = (result) => result.type === Listed && result.domain;

/**
 * Extracts the hostname from a domain name, handling cases where the user may have included a protocol or path.
 * @param {string} domainName - The domain name as entered by the user (may include protocol, path, etc.)
 * @returns {string} - The hostname only (e.g., "example.com")
 */
export const stripProtocolAndPath = (domainName) => {
  const domainWithoutProtocol = domainName.replace(/^[^:]*?(:\/\/)/, '');
  return new URL(`${SECURE}${domainWithoutProtocol}`).hostname;
}

/**
 * Checks for a valid domain. This can include www.example.com or example.com or even example.com/path/to/page
 * @param {string} domainName 
 * @returns {boolean}
 */
export const isValidDomain = (domainName) => {
  const domainNameWithProtocol = `${SECURE}${domainName.replace(/^[^:]*?(:\/\/)/, '')}`

  if(!URL.canParse(domainNameWithProtocol)) {
    return false;
  }

  return isValidTldAndHasDomain(parseDomain(fromUrl(domainNameWithProtocol)));
}

export const isValidUrl = (url) => {
  const { type } = parseDomain(fromUrl(url));
  return url.substring(0, 5) === "https" && type === Listed;
};

export const ensureHTTPS = (url) =>
  url ? (url.startsWith(INSECURE) ? url.replace(INSECURE, SECURE) : url) : "";
